/* src/app/components/payroll/timesheets/timesheet-provider-denied-list/timesheet-provider-denied-list.component.css */
:host ::ng-deep tr:has(> td.no-split-entries) > td.expand-row .expand-row-icon-btn {
  visibility: hidden;
  pointer-events: none;
}
/*# sourceMappingURL=timesheet-provider-denied-list.component-Y5RHMS5R.css.map */
